import React from 'react';
import { Button } from 'antd';
import cx from 'classnames';

import { ReactComponent as StarIcon } from '../../../../assets/sightx-icons/svg/sx-star-plus.svg';
import { Features, isFeatureEnabled } from '../../../../featureToggles/features';
import { redirectToUpgradeToPro } from '../../../../utils/utils';
import { useDispatch } from 'react-redux';

import styles from './index.module.scss';

const isTrialsEnvEnabled = isFeatureEnabled(Features.TrialsOfTiers);

interface IProps {
  className?: string;
}

export const UpgradeToProCTA: React.FunctionComponent<IProps> = ({ className }) => {
  const dispatch = useDispatch();
  if (!isTrialsEnvEnabled) {
    return null;
  }
  const handleClick = () => {
    dispatch(redirectToUpgradeToPro());
  };

  return (
    <Button className={cx(styles.upgradeButton, className)} onClick={handleClick}>
      <span className={styles.title}>Upgrade to Pro <StarIcon/></span>
    </Button>
  );
};